const state = {
  typologyEdit: null,
  typologyDelete: null
}

export default state